import { render } from "./QuantityComponent.vue?vue&type=template&id=bbbc08cc&scoped=true"
import script from "./QuantityComponent.vue?vue&type=script&lang=js"
export * from "./QuantityComponent.vue?vue&type=script&lang=js"

import "./QuantityComponent.vue?vue&type=style&index=0&id=bbbc08cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbc08cc"]])

export default __exports__